<template>
    <div>
        <p class="is-size-7 has-text-grey-light mb-2">{{ translate("predefined_notification.example_note") }}</p>
        <div class="clarity-mask">
            <iframe class="example-email" sandbox="" :srcdoc="html" :title="translate('predefined_notification.example_note')"></iframe>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";

    defineProps<{
        html: string;
    }>();
</script>

<style scoped>
    .example-email {
        width: 100%;
        height: 24rem;
        border: 0;
        border-radius: 4px;
        background: #fff;
    }
</style>
